import React from 'react';
import Victual from '../../Victual/Victual';

export default () => {
  return (
    <div className='list'>
      <h2 id='sweets'>Sweets</h2>
      <Victual name='Imagawayaki' 
      desc='Batter filled with azuki bean paste'
      price='5.00'/>
      <Victual name='Coffee jelly' 
      desc='Lorum ipsum'
      price='4.00'/>
      <Victual name='Melonpan' 
      desc='Lorum ipsum'
      price='6.20'/>
      <Victual name='Sata andagi' 
      desc='Lorum ipsum'
      price='5.15'/>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Menu/Categories/Sweets/Sweets.js